import React from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import '../css/regokas.css';
import _ from 'lodash';
import Loader from '../components/loader';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import {
    TextField, Select, MenuItem, FormControl, InputLabel, Button, Avatar,
    Box, Grid, Typography, Divider, Modal
} from '@mui/material';

class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        const avatarContext = require.context('../images/avatar', false, /\.jpg$/);
        const avatars = avatarContext.keys().map(avatarContext);
        this.state = {
            profilePicture: null,
            isAvatarModalOpen: false,
            avatars: avatars,
            fullName: '',
            username: '',
            email: '',
            phone: '',
            dob: '',
            gender: '',
            bio: '',
            address: '',
            country: '',
            state: '',
            city: '',
            postalCode: '',
            linkedIn: '',
            twitter: '',
            facebook: '',
            instagram: '',
            loader: false,
            imageType: 0,
        };
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    // handleFileChange = (event) => {
    //     this.setState({ profilePicture: URL.createObjectURL(event.target.files[0]) });
    // };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        // console.log(file);
        if (file) {
            const previewUrl = URL.createObjectURL(file);

            // Save file and preview URL separately
            this.setState({
                profilePicture: previewUrl, // for immediate preview
                selectedFile: file,
                imageType: 1,         // real file for uploading
            });
        }
    };


    handleOpenAvatarModal = () => {
        this.setState({ isAvatarModalOpen: true });
    };

    handleCloseAvatarModal = () => {
        this.setState({ isAvatarModalOpen: false });
    };

    handleSelectAvatar = (avatar) => {
        this.setState({ imageType: 0, profilePicture: avatar, isAvatarModalOpen: false });
    };

    componentDidMount() {
        this.getProfileData();
    }



    // handleProfileUpdate = () => {
    //     // Set the loader to true while the request is processing
    //     this.setState({
    //         loader: true,
    //     });

    //     const TokenValue = 'Token ' + localStorage.getItem("auth");
    //     const headers = {
    //         'Content-Type': 'application/json',
    //         'Authorization': TokenValue,
    //         'X-CSRFToken': localStorage.getItem('csrftoken'),
    //     };

    //     // Create the payload with the profile image (from state)
    //     const payload = {
    //         image: this.state.profilePicture, // Profile image (base64 or URL)
    //     };
    //     console.log(this.state.profilePicture)

    //     // Example API endpoint for updating the profile
    //     fetch('/we/upload_image/', {
    //         method: 'POST',
    //         headers: headers, // Use the headers with token and CSRF token
    //         body: JSON.stringify(payload), // Send the payload with image
    //     })
    //     .then(response => {
    //         if (!response.ok) {
    //             // If the response status is not OK, throw an error
    //             throw new Error('Error uploading image: ' + response.statusText);
    //         }
    //         return response.json(); // Parse the response as JSON
    //     })
    //     .then(data => {
    //         // Handle success (e.g., show a success message or update state)
    //         console.log("Profile updated:", data);
    //     })
    //     .catch(error => {
    //         // Handle error (e.g., show an error message)
    //         console.error("Error updating profile:", error);
    //     })
    //     .finally(() => {
    //         // Stop the loader after the request finishes
    //         this.setState({
    //             loader: false,
    //         });
    //     });
    // };

    // handleProfileUpdate = () => {
    //     this.setState({ loader: true });

    //     const formData = new FormData();
    //     formData.append('image', this.state.selectedFile);

    //     const TokenValue = 'Token ' + localStorage.getItem("auth");
    //     const headers = {
    //         'Authorization': TokenValue,
    //         'X-CSRFToken': localStorage.getItem('csrftoken'),
    //         // ❌ Don't set Content-Type manually for FormData
    //     };

    //     fetch('/we/upload_image/', {
    //         method: 'POST',
    //         headers: headers,
    //         body: formData,
    //     })
    //     .then(response => {
    //         if (!response.ok) throw new Error('Error uploading image');
    //         return response.json();
    //     })
    //     .then(data => {
    //         console.log('Profile updated:', data);
    //         if (data.image) {
    //             // Set real server image URL
    //             this.setState({ profilePicturePreview: data.image });
    //         }
    //     })
    //     .catch(error => {
    //         console.error('Error:', error);
    //     })
    //     .finally(() => {
    //         this.setState({ loader: false });
    //     });
    // };

    handleProfileUpdate = () => {
        this.setState({ loader: true });

        const formData = new FormData();

        if (this.state.imageType === 1) {
            formData.append('image', this.state.selectedFile);
        } else if (this.state.imageType === 0) {
            formData.append('image', this.state.profilePicture); // Or avatar ID
        }

        formData.append('upload', this.state.imageType); // 👈 Send 0 or 1

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        };

        fetch('/we/upload_image/', {
            method: 'POST',
            headers,
            body: formData,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Error uploading image');
                return response.json();
            })
            .then((data) => {
                if (data.image) {
                    this.setState({ profilePicturePreview: data.image });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                this.setState({ loader: false });
            });
    };




    getProfileData = () => {
        // Set the loader to true while the request is processing
        this.setState({
            loader: true,
        });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        };

        // Example API endpoint for fetching the profile data
        fetch('/we/upload_image/', {
            method: 'GET',
            headers: headers, // Use the headers with token and CSRF token
        })
            .then(response => {
                if (!response.ok) {
                    // If the response status is not OK, throw an error
                    throw new Error('Error fetching profile data: ' + response.statusText);
                }
                return response.json(); // Parse the response as JSON
            })
            .then(data => {
                // Handle success (e.g., store data in state)
                // console.log("Profile data fetched:", data[0].image);
                this.setState({
                    profilePicture: data[0].image, // Assuming the response has this field
                    //fullName: data.fullName, // Assuming the response has this field
                    email: data.email, // Assuming the response has this field
                });
            })
            .catch(error => {
                // Handle error (e.g., show an error message)
                console.error("Error fetching profile data:", error);
            })
            .finally(() => {
                // Stop the loader after the request finishes
                this.setState({
                    loader: false,
                });
            });
    };

    render() {

        return (
            <Box sx={{
                padding: { xs: '20px', sm: '40px', md: '50px 50px 50px 230px' },
                width: '100%',


            }}>
                {this.state.loader && <Loader />}

                <Box textAlign="center" mb={3} mt={7}>
                    {/* Avatar with Remove Button */}
                    <Box
                        sx={{
                            position: 'relative',  
                            width: { xs: 80, sm: 100, md: 120 },
                            height: { xs: 80, sm: 100, md: 120 },
                            mx: 'auto',

                        }}
                    >
                        <Avatar
                            src={this.state.profilePicture}
                            sx={{
                                width: '100%',
                                height: '100%',
                                border: '2px solid #1976d2',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                '& img': {
                                    objectFit: 'contain', // or 'contain', depending on your use case
                                },

                            }}
                        />

                        {this.state.profilePicture && (
                            <IconButton
                                size="small"
                                onClick={() => this.setState({ profilePicture: '' })}
                                sx={{
                                    position: 'absolute',
                                    top: -10,
                                    right: -10,
                                    backgroundColor: '#fff',
                                    border: '1px solid #ccc',
                                    padding: '2px',
                                    zIndex: 10,
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Box>

                    {/* Hidden file input for uploading custom profile picture */}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={this.handleFileChange}
                        style={{
                            display: 'none',
                            visibility: 'hidden',
                            position: 'absolute',
                            width: 0,
                            height: 0,
                            overflow: 'hidden',

                        }}
                        id="upload-photo"
                    />

                    {/* Custom button to trigger file input */}
                    <label htmlFor="upload-photo">
                        <Button
                            variant="contained"
                            component="span"
                            sx={{
                                mt: 2,
                                backgroundColor: '#1976d2',
                                color: '#fff',
                                '&:hover': { backgroundColor: '#115293' },
                                borderRadius: '20px',
                                padding: { xs: '4px 12px', sm: '6px 16px' }
                            }}
                        >
                            Upload Photo
                        </Button>
                    </label>

                    {/* Button to select Avatar */}
                    <Button
                        variant="contained"
                        sx={{
                            mt: 2,
                            ml: 2,
                            backgroundColor: '#4caf50',
                            color: '#fff',
                            '&:hover': { backgroundColor: '#388e3c' },
                            borderRadius: '20px',
                            padding: { xs: '4px 12px', sm: '6px 16px' }
                        }}
                        onClick={this.handleOpenAvatarModal}
                    >
                        Choose Avatar
                    </Button>

                    {/* Optional user info */}
                    {/* <Typography variant="h6" mt={2}>
      {this.state.fullName || "User Name"}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {this.state.email || "user@example.com"}
    </Typography> */}
                </Box>



                <Divider />

                {/* Form Fields */}
                <Grid container spacing={2}>
                    {/* <Grid item xs={12} sm={6}><TextField variant="standard" label="Full Name" name="fullName" value={this.state.fullName} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Username" name="username" value={this.state.username} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Email" name="email" value={this.state.email} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Phone" name="phone" value={this.state.phone} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Date of Birth" name="dob" type="date" InputLabelProps={{ shrink: true }} value={this.state.dob} onChange={this.handleInputChange} fullWidth /></Grid> */}

                    {/* <Grid item xs={12} sm={6} mt={1}>
                        <FormControl fullWidth>
                            <InputLabel sx={{ textAlign: 'start' }}>Gender</InputLabel>
                            <Select variant="standard" name="gender" value={this.state.gender} onChange={this.handleInputChange}>
                                <MenuItem value="Male">Male</MenuItem>
                                <MenuItem value="Female">Female</MenuItem>
                                <MenuItem value="Non-binary">Non-binary</MenuItem>
                                <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid> */}

                    {/* <Grid item xs={12}><TextField variant="standard" label="Bio" name="bio" value={this.state.bio} onChange={this.handleInputChange} fullWidth multiline rows={3} /></Grid>
                    <Grid item xs={12}><TextField variant="standard" label="Address" name="address" value={this.state.address} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Country" name="country" value={this.state.country} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="State" name="state" value={this.state.state} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="City" name="city" value={this.state.city} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Postal Code" name="postalCode" value={this.state.postalCode} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="LinkedIn" name="linkedIn" value={this.state.linkedIn} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Twitter/X" name="twitter" value={this.state.twitter} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Facebook" name="facebook" value={this.state.facebook} onChange={this.handleInputChange} fullWidth /></Grid>
                    <Grid item xs={12} sm={6}><TextField variant="standard" label="Instagram" name="instagram" value={this.state.instagram} onChange={this.handleInputChange} fullWidth /></Grid> */}

                    {/* Buttons */}
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        justifyContent={{ xs: "center", md: "flex-end" }}
                        gap={2}
                        marginTop={10}
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                            // onClick={() => window.location.href = '/dashboard'}
                            onClick={() => window.history.back()} // vanilla JS

                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.handleProfileUpdate}
                            color="primary"
                            size="large"
                            sx={{ width: { xs: '100%', sm: 'auto' } }}
                        >
                            Save Profile
                        </Button>
                    </Grid>

                </Grid>

                <Modal open={this.state.isAvatarModalOpen} onClose={this.handleCloseAvatarModal}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 500, // Increased width
                        height: 500, // Adjusted height
                        overflowY: 'auto', // Enable scrolling if content is large
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                        position: 'relative' // Required for absolute positioning of close button
                    }}>
                        {/* Close Button at the Top Right */}
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                color: 'gray'
                            }}
                            onClick={this.handleCloseAvatarModal}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Typography variant="h6" mb={2} textAlign="start">
                            Choose an Avatar
                        </Typography>

                        <Grid container spacing={2}>
                            {this.state.avatars.map((avatar, index) => (
                                <Grid item xs={2.4} key={index}> {/* 5 avatars per row */}
                                    <Avatar src={avatar} sx={{ width: 80, height: 80, cursor: 'pointer' }}
                                        onClick={() => this.handleSelectAvatar(avatar)}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Modal>

            </Box>
        );
    }
}

const mapStateToProps = state => ({ redux: state });
export default connect(mapStateToProps)(UserProfile);
